import 'core-js/stable';
import 'regenerator-runtime/runtime';
import $ from 'jquery';
import 'global/od/index';

import addToCart from 'global/addToCart/addToCart';
import CustomerService from 'global/common/customerService/CustomerService';
import equalHeights from 'global/equalHeights';
import Header from 'global/header/header';
import imageLazyLoad from 'global/common/imageLazyLoad';
import imageLazyLoadMutationObserver from 'global/common/imageLazyLoadMutationObserver';
import InkTonerAssistedSearchManager from 'global/inkAndTonerAssistedSearch/InkTonerAssistedSearchManager';
import { enhancedChatSetup } from 'global/common/enhancedChatSetup';
import Navigation from 'global/Navigation';
import SiteSecondaryNavigation from 'global/siteSecondaryNavigation';
import { newsletterBox } from 'global/common/newsletterBox';
import ProductCustomisable from 'global/product/ProductCustomisable';
import initAlgonomy from 'global/recomendations/initAlgonomy';
import registrationBillingForm from 'global/registration/registrationBillingForm';
import quantityInput from 'global/quantityInput';
import 'global/inputFocusSelection';
import ShoppingLists from 'global/shoppingLists/ShoppingLists';
import showHide from 'global/togglePassword';
import SwitchAndSave from 'global/switchAndSave/SwitchAndSave';
import siteFlash from 'global/header/siteFlash';
import EmailAlreadyRegistered from 'global/emailAlreadyRegistered/EmailAlreadyRegistered';
import choicesControlValidationFactory from 'global/ChoicesControlValidationFactory';
import NotifyMeWhenInStock from 'global/notifyMeWhenInStock/notifyMeWhenInStock';
import SelectDeliveryDate from 'global/selectDeliveryDate/SelectDeliveryDate';
import GtmTrackingManager from 'global/gtm/gtmTrackingManager';
import { addErrorEventListener } from 'global/jsErrorsPublisher';
import { subscribeToJSErrors } from 'global/logging/jsErrorsLogToServer';
import nectarFormSubmit from 'global/loyalty/nectarFormSubmit';
import nectarLegalLink from 'global/loyalty/nectarModal';
import generalNotification from 'global/header/generalNotification';
import { initCarouselCustomSettings } from 'global/od/carousel';
import ExperianAddressValidation from 'global/experianAddressValidation';
import ShowMoreLess from 'global/common/showMoreLess';
import sessionTimeoutLogoutFlow from 'global/common/sessionTimeoutLogoutFlow';
import popoverPanel from 'global/od/popoverPanel';
import Rating from 'global/od/rating';
import PostalCodeValidation from 'global/postalCodeValidation';
import CountryValidation from 'global/countryValidation';
import AddressElementsInCheckout from 'global/addressElementsInCheckout';
import getQuote from 'global/getQuote';
import { formSelectWithToolTip } from 'global/formSelectWithToolTip';
import ProductPriceTable from 'global/product/productPriceTable';
import salesforceIframeSetup from 'global/thirdParties/salesforceIframeSetup';
import CreditsafeCompanySearch from './global/creditsafeCompanySearch';

// Polyfills
import initAnchorPositioningPolyfill from './polyfills/anchorPositioningPolyfill';

const breakpoints = {
	lg: 992,
};

// Polyfills
initAnchorPositioningPolyfill();

new Header('header');

addErrorEventListener();
subscribeToJSErrors();

imageLazyLoad();
imageLazyLoadMutationObserver();

new ShoppingLists();

addToCart();

new SwitchAndSave();

popoverPanel();

new Rating();

setTimeout(() => {
	$('[data-toggle="tooltip"]').tooltip();
}, 1000);

// Site Navigation
new Navigation();

// Site Secondary Navigation
if (window.innerWidth >= breakpoints.lg) {
	const secondaryNavigation = new SiteSecondaryNavigation();
	secondaryNavigation.init();
}

// Session Timeout
sessionTimeoutLogoutFlow();

// Toggle Password show/hide
if (document.querySelector('[data-toggle-password="true"]')) {
	showHide('[data-toggle-password="true"]');
}

// Common Form Control instance
const { FormControl } = window.od;
const formValidation = document.querySelectorAll('[data-validation="true"]');

Array.from(formValidation).forEach(form => new FormControl(form));

// Customer service panel
const customerServiceOptions = {
	wrapper: 'customerServicePanel',
};

new CustomerService(customerServiceOptions);

// Chat
const enhancedChat = document
	.querySelector('#enhancedChatSetup')
	?.getAttribute('data-organization-id');

if (enhancedChat) enhancedChatSetup();

initAlgonomy();

document.addEventListener('DOMContentLoaded', () => {
	siteFlash();
	generalNotification();
});

quantityInput();
new ProductCustomisable();

new ProductPriceTable();

equalHeights();

const carousels = document.querySelectorAll('[data-carousel]');
Array.from(carousels).forEach(window.od.carousel);

initCarouselCustomSettings();
formSelectWithToolTip();

new EmailAlreadyRegistered();
choicesControlValidationFactory();

new NotifyMeWhenInStock();

const inkTonerAssistedSearches = document.querySelectorAll(
	'[data-inktoner-assistedsearch]',
);
inkTonerAssistedSearches.forEach((assistedSearch, assistedSearchIndex) => {
	new InkTonerAssistedSearchManager(assistedSearch, assistedSearchIndex);
});

const selectDeliveryDateElement = document.getElementById('selectDeliveryDate');
if (selectDeliveryDateElement)
	new SelectDeliveryDate(selectDeliveryDateElement);

GtmTrackingManager();

nectarFormSubmit();

const nectarLink = document.querySelector('#nectarLegal');
nectarLegalLink(nectarLink);

const newsletterBoxElement = document.querySelector('.newsletter-box');
if (newsletterBoxElement) newsletterBox(newsletterBoxElement);

new ExperianAddressValidation().init();

const creditsafeCompanySearchForm = document.getElementById(
	'creditsafeCompanySearchForm',
);
if (creditsafeCompanySearchForm)
	new CreditsafeCompanySearch(creditsafeCompanySearchForm);

const showMoreLessContainers = document.querySelectorAll(
	'.js-show-more-container',
);
if (showMoreLessContainers) {
	showMoreLessContainers.forEach(container => {
		new ShowMoreLess(container).init();
	});
}

new PostalCodeValidation().init();
new CountryValidation().init();

const addressSearchSections = document.querySelectorAll(
	'.js-address-search-section',
);
if (addressSearchSections) {
	addressSearchSections.forEach(section => {
		new AddressElementsInCheckout(section).init();
	});
}

getQuote();

const billingForm = document.getElementById('billingForm');
if (billingForm) {
	registrationBillingForm(billingForm);
}

salesforceIframeSetup('footerEmailSignup');
